import isolation from "../assets/images/isolation.png";
import alert from "../assets/icons/alert.png";
import narrative from "../assets/icons/narrative.png";
import ai from "../assets/icons/ai.png";
import search from "../assets/icons/search.png";
import feeds from "../assets/icons/feeds.png";
import calendar from "../assets/icons/calendar.png";
import tracking from "../assets/icons/tracking.png";
import token from "../assets/icons/token.png";
import audio from "../assets/icons/head.png";
import { useState } from "react";

export default function BannerComponent() {
  const [screenWidth] = useState<number>(window.screen.width);

  const items = [
    {
      icons: "",
      label: "",
    },
    {
      icons: "",
      label: "",
    },
    {
      icons: search,
      label: "MetaSearch",
    },
    {
      icons: tracking,
      label: "Sentiment Tracking",
    },
    {
      icons: "",
      label: "",
    },
    {
      icons: alert,
      label: "Smart Alerts",
    },
    {
      icons: feeds,
      label: "Dashboard & Feeds",
    },
    {
      icons: token,
      label: "Token Mindshare",
    },
    {
      icons: "",
      label: "",
    },
    {
      icons: narrative,
      label: "Narrative Mindshare",
    },
    {
      icons: calendar,
      label: "Catalyst Calendar",
    },
    {
      icons: audio,
      label: "Audio Library",
    },
    {
      icons: "",
      label: "",
    },
    {
      icons: ai,
      label: "AI Copilot",
    },
    {
      icons: "",
      label: "",
    },
    {
      icons: "",
      label: "",
    },
  ];

  return (
    <section className="pt-[134px] sm:mb-[70px] mb-[20px] max-w-7xl mx-auto my-4 px-4 relative">
      <div className="flex items-center flex-col-reverse lg:flex-row justify-center lg:justify-between gap-8">
        <div>
          <h3 className="text-linear funnel-display-semibold lg:leading-[86px] text-4xl md:text-7xl text-center lg:text-left">
            Web3 Information
          </h3>
          <h3 className="text-linear funnel-display-semibold lg:leading-[86px] text-4xl md:text-7xl text-center lg:text-left">
            Platform
          </h3>

          <p className="funnel-display-regular mt-4 text-xl text-[#8C8C8C] max-w-[610px] text-center lg:text-left">
            The ultimate AI-powered Web3 information platform you need to turn
            terabytes of unstructured information into actional insights.
          </p>

          <div className="flex items-center gap-4 mt-[40px] lg:justify-start justify-center">
            <button className="btn-primary funnel-display-semibold text-base text-white py-3 px-4 border border-solid rounded-xl border-[#FE0101] bg-[#FE0101] transition-all duration-300">
              Sign Up Now
            </button>
            <button className="btn-secondary funnel-display-semibold text-base text-white py-3 px-4 border border-solid rounded-xl border-[#454545] bg-[#1F1F1F] transition-all duration-300">
              Explore Pricing
            </button>
          </div>
        </div>

        <img src={isolation} alt="isolation" className="max-w-[338px]" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 mt-16 gap-4">
        {items
          .filter((item) =>
            screenWidth < 1025 ? item.icons : !item.icons || item.icons
          )
          .map((item, index) => (
            <div
              className={`${
                item.icons
                  ? "border bg-[linear-gradient(180deg,#1F1F1F_0%,rgba(31,31,31,0.4)_100%)] cursor-pointer"
                  : ""
              } pt-8 px-8 pb-4 border-solid border-[#262626] rounded-xl`}
              key={index}
            >
              {item.icons && (
                <img
                  src={item.icons}
                  alt={item.icons.toString()}
                  className="w-8 h-8"
                />
              )}
              <p className="mt-3 text-[#FCFCFC] text-lg funnel-display-semibold">
                {item.label}
              </p>
            </div>
          ))}
      </div>
    </section>
  );
}
